module.exports = __webpack_public_path__ + "static/media/OCTA.NET.1107e130.png";